<div class="build-your-profile-section-nav">
  <ul>
    <li class="build-your-profile-section-nav__item guts-p-full-1-half">
      <div
        class="l_flex build-your-profile-section-nav__vertical-line build-your-profile-section-nav__section-menu build-your-profile-section-nav__section-menu--last"
      >
        <div
          class="l_flex build-your-profile-section-nav__section-menu--progress-items height-auto full-width"
          tabindex="0"
        >
          <dgx-progress-circle
            *ngIf="!hasParsedResume"
            [percent]="1"
            [config]="{
              color: progressCircleInProgress,
              bgcolor: progressCircleTrailColor,
              radius: 8
            }"
          ></dgx-progress-circle>
          <img
            *ngIf="hasParsedResume"
            [alt]="indicatorText"
            role="img"
            [src]="completedImg | blobifyUrl: true"
            data-dgat="parsed-resume-indicator-200"
          />
          <p class="par par--small par--light_a guts-p-l-1 full-width">
            {{ indicatorText }}
          </p>

          <button
            class="color-blue par--small font-medium uhover guts-m-l-1-half"
            (click)="trackGoToResumeParsing()"
            data-dgat="parsed-resume-indicator-970"
          >
            {{ i18n.Core_Upload | translate }}
          </button>
        </div>
      </div>
    </li>
  </ul>
</div>
